import typography from './Typography.scss';
export * from './Utils';

export default typography;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Typography/index.js